import styled from "styled-components";

export const FilterTag = styled.button`
  color: var(--ons-color-black);
  border-radius: 3px;
  border: 1px solid var(--ons-color-grey-35);
  background-color: var(--ons-color-grey-5);
  padding: 4px 7px;
  display: flex;

  svg {
    fill: var(--ons-color-grey-75);
    padding: 0px 0px 0px 4px;
    height: auto;
    width: auto;
    display: block;
  }

  &:hover {
    background-color: var(--ons-color-grey-15);
    cursor: pointer;
  }

  &:focus {
    border: 2px solid var(--ons-color-black);
    background-color: var(--ons-color-sun-yellow);
  }
`;

export const FilterTagText = styled.span`
  font-size: 14px;
  display: block;
  text-align: left;
  line-height: 24px;
`;
